import { render, staticRenderFns } from "./DispensationRecorder.vue?vue&type=template&id=9719011e&scoped=true&"
import script from "./DispensationRecorder.vue?vue&type=script&lang=js&"
export * from "./DispensationRecorder.vue?vue&type=script&lang=js&"
import style0 from "./DispensationRecorder.vue?vue&type=style&index=0&id=9719011e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9719011e",
  null
  
)

export default component.exports